import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { apiService } from '@/services/api';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, updateUser } = useAuthStore();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    let cancelled = false;
    const refreshProfile = async () => {
      try {
        const profile = await apiService.get('/auth/profile');
        if (!cancelled && profile) {
          updateUser(profile);
        }
      } catch (error) {
        console.error('Could not refresh user profile:', error);
      }
    };

    refreshProfile();
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, updateUser]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
